module.exports = __webpack_public_path__ + "img/content0.190862a5.png";